import { makeResetStyles, shorthands } from '@fluentui/react-components';

export const useColorButtonStyles = makeResetStyles({
  width: '34px',
  height: '34px',
  ...shorthands.borderRadius('9999px'),
  ...shorthands.border('1px', 'solid', '#D1D1D1'),
  cursor: 'pointer',
  ...shorthands.overflow('hidden'),
});
